module.exports = __webpack_public_path__ + "static/media/content2Curve.dac4a36d.svg";